export default __webpack_public_path__ + "static/media/dog-finding.cc21a5eb.png";